import MainButtons from "../../butttons/mainButtons/MainButtons";
import Footer from "../../components/Footer/Footer";
import Gallery from "../../components/Gallery/Gallery";
import Header from "../../components/Header/Header";
import User from "../../components/User/User";
const UserPage = () => {
  return (
    <div>
      <Header/>
      <User/>
      <MainButtons/>
      <Gallery/>
      <Footer/>
      </div>
  );
};

export default UserPage;
